import { render } from "./projectDone.vue?vue&type=template&id=4c0f0809"
import script from "./projectDone.vue?vue&type=script&lang=js"
export * from "./projectDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__